module.exports = __webpack_public_path__ + "img/user.635563ba.png";